import { render } from "./GameNotes.vue?vue&type=template&id=494264c4&scoped=true"
import script from "./GameNotes.vue?vue&type=script&lang=js"
export * from "./GameNotes.vue?vue&type=script&lang=js"

import "./GameNotes.vue?vue&type=style&index=0&id=494264c4&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-494264c4"]])

export default __exports__